import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedProperty: null, // used for viewing property details
  selectedProperties: [] // used for exporting
};

const propertiesTable = createSlice({
  name: 'propertiesTable',
  initialState,
  reducers: {
    setSelectedProperty(state, action) {
      const { selectedProperty } = action.payload;
      state.selectedProperty = selectedProperty;
    },
    setSelectedProperties(state, action) {
      const { selectedProperties } = action.payload;
      state.selectedProperties = selectedProperties;
    }
  }
});

export const {
  setSelectedProperty,
  setSelectedProperties
} = propertiesTable.actions;

export default propertiesTable.reducer;